import { useQuery } from "@tanstack/react-query";
import React from "react";
import { API } from "../../../API";
import { AgencyId, CaregiverComplianceItemMobile } from "../../../messages";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import ErrorScaffold from "../../ErrorScaffold";
import AppModal from "../../Generic/AppModal/AppModal";
import useModal from "../../useModal";
import { withMedflytAgencyId } from "../../withMedflytAgencyId";
import CompliantItemsScreen from "./CompliantItemsScreen";
import MyMedflytComplianceScreen from "./MyMedflytComplianceScreen";

interface Props {
  api: API;
  medflytAgencyId: AgencyId;
  onClickComplianceItem: (item: CaregiverComplianceItemMobile) => void;
  onClickGoBack: () => void;
}

function CompliantItemsActivity(props: Props) {
  const query = useQuery({
    queryKey: ["compliance_items", props.medflytAgencyId],
    queryFn: () => props.api.getComplianceItems(props.medflytAgencyId),
  });

  const modal = useModal();

  if (query.isError) {
    return (
      <ErrorScaffold
        title={translate(STRINGS.ONBOARDING)}
        message={translate(STRINGS.SOMETHING_WENT_WRONG)}
        onClickRetry={query.refetch}
        onClickGoBack={props.onClickGoBack}
      />
    );
  }

  if (query.isLoading) {
    return <MyMedflytComplianceScreen isLoading={true} onClickGoBack={props.onClickGoBack} />;
  }

  return (
    <>
      <CompliantItemsScreen
        isLoading={false}
        items={query.data.items}
        onClickComplianceItem={props.onClickComplianceItem}
        onClickGoBack={props.onClickGoBack}
      />
      <AppModal {...modal.modalProps} />
    </>
  );
}

export default withMedflytAgencyId(CompliantItemsActivity);
